import { createApiHandler } from 'react-lib/dist/agent-es';
import { createBrowserHistory } from 'history';
import { keycloakConfig } from './keycloak';

export const history = createBrowserHistory({
  forceRefresh: true,
});

export const baseUrl = '/api';

const apiConfig = {
  baseURL: baseUrl,
  config: {
    redirect: '/',
  },
};

export const api = createApiHandler(apiConfig, null, null, keycloakConfig);

export default { api, apiConfig };
